<template>
  <v-app>
    <v-main>
      <menu-dashboard />

      <div style="margin-top: 90px; margin-bottom: 90px">
        <router-view />
      </div>

      <footer-dashboard />
    </v-main>
  </v-app>
</template>

<script>

import MenuDashboard from "@/menu/dashboard";
import FooterDashboard from "@/footer/dashboard";

export default {
  name: "layoutDashboard",

  components: {
    FooterDashboard,
    MenuDashboard,
  }
};
</script>
